export const isImage = (mimeType: string) => mimeType.split('/')[0] === 'image';
